<div class="location-selector flex relative fill grow">
  <fin-booking-widget-selector
    class="flex--basis-half"
    [label]="'bookingSearch.from.title' | finLocalization"
    [disabled]="originDisabled || disabled"
    (click)="openModal('origin')"
    [position]="'left'"
    [filled]="(locationPair$ | async)?.origin !== undefined"
    [placeholder]="'bookingSearch.boundSelection.originPlaceholder' | finLocalization"
    [attr.data-test-location-selector]="'origin'"
  >
    <ng-container
      *ngTemplateOutlet="locationInfo; context: { location: (locationPair$ | async)?.origin }"
    ></ng-container>
  </fin-booking-widget-selector>

  <ng-container *ngIf="showSeparator">
    <fcom-icon-button
      class="flex flex--center flex--self-center absolute location-switch"
      [icon]="{ category: 'svg-library', name: 'switch-flights' }"
      [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [size]="IconButtonSize.MEDIUM"
      [aria]="{ label: 'bookingSearch.aria.fromToSwitch' | finLocalization }"
      (clickBtn)="locationsSwitched.emit()"
      data-test-switch-locations
    >
    </fcom-icon-button>
  </ng-container>

  <fin-booking-widget-selector
    class="flex--basis-half"
    [label]="'bookingSearch.to.title' | finLocalization"
    [disabled]="destinationDisabled || disabled"
    (click)="openModal('destination')"
    [position]="'right'"
    [filled]="(locationPair$ | async)?.destination !== undefined"
    [placeholder]="'bookingSearch.boundSelection.destinationPlaceholder' | finLocalization"
    [attr.data-test-location-selector]="'destination'"
  >
    <ng-container
      *ngTemplateOutlet="locationInfo; context: { location: (locationPair$ | async)?.destination }"
    ></ng-container>
  </fin-booking-widget-selector>
</div>

<fcom-modal
  *ngIf="locationType$ | async as locationType"
  [(open)]="modalOpen"
  [title]="'bookingSearch.' + (locationType === 'origin' ? 'from' : 'to') + '.title' | finLocalization"
  [fitToContent]="false"
  [focusTarget]="searchInput.inputElement"
  [buttons]="null"
  (close)="closeModal()"
  data-test-location-modal
>
  <div>
    <div class="search-form flex flex--middle pr-large-x ps-small-y" data-test-location-search-form>
      <fcom-text-input
        class="flex-1"
        [id]="'locationSearch-input'"
        [parentForm]="locationSearchForm"
        [translationPrefix]="'bookingWidget.destinationSearch.' + (locationType === 'origin' ? 'from' : 'to')"
        [controlName]="'locationSearch'"
        [required]="false"
        [placeHolder]="'bookingSearch.' + (locationType === 'origin' ? 'from' : 'to') + '.inputPlaceholder'"
        [displayMargin]="false"
        [ariaOptions]="{ describedby: 'location-search-info' }"
        [disableAutoComplete]="true"
        (keydown.enter)="moveFocusToResults($event)"
        #searchInput
        data-test-search-input
      ></fcom-text-input>

      <div *ngIf="showLocateMe && locationType === 'origin'" class="locate-me flex flex--end mr-xxsmall-l">
        <fcom-button
          *ngIf="locationType === 'origin'"
          (click)="getUserLocation()"
          [text]="'bookingSearch.locateMe' | finLocalization"
          [icon]="{ category: 'svg-library', name: 'gps-location', position: IconPosition.RIGHT }"
          [mode]="ButtonMode.INLINE"
          [size]="ButtonSize.R_SMALL"
          [theme]="ButtonTheme.TERTIARY"
          [loading]="isGeoLocating$ | async"
          [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
          data-test-locateMe
        >
        </fcom-button>
      </div>

      <p id="location-search-info" class="is-vishidden">
        {{ 'bookingSearch.a11y.locationSearchDescription.' + locationType | finLocalization }}
      </p>
    </div>

    <fin-previous-searches
      *ngIf="
        showPreviousSearches &&
        (enablePersonalization$ | async) === true &&
        modalOpen &&
        (queryString$ | async)?.length === 0
      "
      (closeLocationModal)="closeModal()"
      (focusOnSearchInput)="moveFocusToSearchInput()"
    ></fin-previous-searches>

    <div
      class="grey-50-bg rounded-small pr-large-x ps-medium-y"
      *ngIf="hasLocations$ | async"
      data-test-location-list-header
    >
      <h3
        class="font-body-1 nordic-blue-900-text"
        [attr.id]="locationType + '-list-title'"
        [tabIndex]="-1"
        #locationListHeading
      >
        <span data-test-location-list-title>
          {{
            (queryString$ | async)?.length > 0 || isAm
              ? ((locationType === 'origin' ? 'bookingSearch.from.header' : 'bookingSearch.to.headerNoFrom')
                | finLocalization)
              : ((locationType === 'origin' ? 'bookingSearch.from.nearestAiport' : 'trendingDestinations')
                | finLocalization)
          }}
        </span>

        <span *ngIf="(queryString$ | async)?.length > 0" class="is-vishidden" data-test-location-list-results-found>
          &nbsp;{{
            'bookingSearch.a11y.found.' + (locationType === 'origin' ? 'locations' : 'destinations')
              | finLocalization: [(locationResults$ | async)?.length]
          }}</span
        >
      </h3>
    </div>

    <ng-container *ngIf="(isLoading$ | async) === false">
      <ul
        class="flex flex--column"
        tabindex="-1"
        role="listbox"
        [attr.id]="'to-location-' + locationType"
        [attr.aria-labelledby]="locationType + '-list-title'"
        [attr.aria-active-descendant]="'to-location-' + locationType + '-' + (this.activeIndex$ | async)"
      >
        <li
          *ngFor="
            let location of (queryString$ | async)?.length > 0
              ? (locationResults$ | async)
              : (defaultLocations$ | async) as locations;
            let i = index;
            let first = first;
            let last = last
          "
          class="flex flex--middle flex--space-between focus-inset link-hover pr-large-x"
          [class.border-bottom]="!last"
          [class.nordic-blue-50-bg]="i === (this.activeIndex$ | async)"
          [class.nordic-blue-50-border]="i === (this.activeIndex$ | async)"
          [attr.id]="'to-location-' + locationType + '-' + i"
          role="none presentation"
        >
          <button
            class="flex flex--column fill ps-medium-y"
            [tabindex]="
              ((this.activeIndex$ | async) === undefined && first) || (this.activeIndex$ | async) === i ? 0 : -1
            "
            [attr.aria-selected]="i === (this.activeIndex$ | async)"
            role="option"
            (click)="locationSelected.emit({ location, locationType })"
            (keydown)="handleKeyDown($event, locations)"
            #locationItem
            data-test-location-item
          >
            <div class="font-body-1 capitalize location-title">
              <ng-container *ngTemplateOutlet="locationInfo; context: { location: location }"></ng-container>
            </div>
            <div class="font-body-2 ps-xxsmall-y nordic-blue-900-text align-left">
              <i class="flag--small flag-{{ location.countryCode }}"></i>&nbsp;{{ location.title }}
            </div>
          </button>
        </li>
      </ul>
    </ng-container>

    <div role="status" aria-live="assertive" [tabIndex]="-1">
      <p
        *ngIf="
          (queryString$ | async)?.length > 0 &&
          (isLoading$ | async) === false &&
          (locationResults$ | async)?.length === 0
        "
        class="pr-large-x pr-medium-y"
      >
        {{ 'bookingSearch.a11y.found.notFound' | finLocalization: [queryString$ | async] }}
      </p>
    </div>

    <fcom-loader *ngIf="isLoading$ | async" class="pr-large" [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
</fcom-modal>

<ng-template #locationInfo let-location="location">
  <div *ngIf="location" class="flex fill" data-test-location-info>
    <span class="overflow-hidden truncate">
      {{ location.cityName }}
    </span>
    <span *ngIf="!isAm">
      &nbsp;({{
        location.locationCode && location.type === 'airport'
          ? location.locationCode
          : ('bookingSearch.allAirportsLabel' | finLocalization)
      }})</span
    >
    <span class="is-vishidden">&nbsp;{{ location.country }}.</span>
  </div>
</ng-template>
